import { useRoutes } from "react-router-dom";
import { useAppRoutes } from "./constants";

function Router() {
  const routes = useAppRoutes()
  return useRoutes(routes);
}

export default Router;
